<template>


  <div v-if="((brandedApp.is_hidden === 0) && ((brandedApp.ios_link != '') || (brandedApp.android_link != '')))" id="branded_apps" class="col-md-12">

    <div v-if="brandedApp.promotion_img != null" class="img col-md-6">
      <img :src="brandedApp.promotion_img"/>
    </div>

    <div v-if="brandedApp.promotion_content != null" class="text col-md-6 promotion_content">
      <span v-html="brandedApp.promotion_content"></span>
    </div>

  </div><!--end of branded_apps-->
</template>


<script>

import {getBrandedApps} from "@/modules/CustomerPortal/api/brandedApps";
export default {
  name: "BrandedApps",
  props: [
      "company_id",
  ],
  data() {
    return {
      brandedApp : '',
      socialNetworks : '',
      brandedApp_promotion_content : '',
    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){
    getBrandedApps(this.company_id).then((response) => {
      if(response.status == 200){
        if(response.data.type == 'success'){
          this.brandedApp = response.data.brandedApp;
          this.socialNetworks = response.data.socialNetworks;
          this.brandedApp_promotion_content = response.data.brandedApp_promotion_content;
        }
      }
    })
  }
}
</script>
